import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 .5C4.48.5 0 4.98 0 10.5s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L14.9 16.81A7.902 7.902 0 0110 18.5zm6.31-3.1L5.1 4.19A7.902 7.902 0 0110 2.5c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" fill="#6F6F6F" /></svg>;